import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { IPalominaSeo } from '@palomina/palomina-sanity';
import { useSiteMetadata } from '@palomina/palomina-website/hooks';
import FacebookSEO from './Facebook';
import TwitterSEO from './Twitter';

interface IProps {
  pageTitle: string;
  description?: string;
  openGraphImageUrl?: string;
  keywords?: string[];
  pathname?: string;
}

const SEO = ({
  pageTitle,
  pathname,
  description: pageDescription,
  openGraphImageUrl
}: IProps) => {
  const globalSEO: IPalominaSeo = useStaticQuery(graphql`
    query {
      sanityPalominaSettings {
        seo {
          title
          keywords
          # tagline
          description
          image {
            asset {
              url
            }
          }
          # favicon {
          #   asset {
          #     url
          #   }
          # }
        }
      }
    }
  `)?.sanityPalominaSettings?.seo;

  const meta = useSiteMetadata();

  if (!globalSEO) {
    return null;
  }

  const {
    description: globalDescription,
    favicon,
    image,
    keywords,
    // tagline,
    title: globalTitle
  } = globalSEO;

  const titleText =
    pageTitle === `Home` ? `${globalTitle}` : `${pageTitle} | ${globalTitle}`;
  const descriptionText = pageDescription || globalDescription;
  const ogImageUrl = openGraphImageUrl || image.asset.url!;
  const faviconUrl = favicon?.asset?.url!;
  const keywordsText = keywords ? keywords.join(', ') : null;

  return (
    <>
      <title>{titleText}</title>
      <link rel="icon" type="image/png" href={faviconUrl} />
      <link rel="canonical" href={`${meta.siteUrl}${pathname}`} />
      <meta name="description" content={descriptionText} />

      {keywordsText && <meta name="keywords" content={keywordsText} />}

      <FacebookSEO
        description={descriptionText}
        ogImageUrl={ogImageUrl}
        siteUrl={meta.siteUrl}
        title={titleText}
      />
      <TwitterSEO
        description={descriptionText}
        ogImageUrl={ogImageUrl}
        title={titleText}
      />
    </>
  );
};

export default SEO;
